// extracted by mini-css-extract-plugin
export default {"login":"OrderClientInput_login__raXID"};